import type { SerializedError } from "@reduxjs/toolkit";
import { match } from "ts-pattern";

import type { CustomBaseQueryError } from "api/types/error";
import { isCustomBaseQueryError } from "api/utils";
import * as Styled from "common/components/ApiErrorMessage/ApiErrorMessage.styled";

type ApiErrorMessageProps = {
  error?: CustomBaseQueryError | SerializedError;
};

export const ApiErrorMessage = ({ error }: ApiErrorMessageProps) => {
  const getErrorMessage = () => {
    if (isCustomBaseQueryError(error)) {
      return match(error.status)
        .with(
          "SCHEMA_VALIDATION_ERROR",
          () => "There was a problem processing the data from the server. Please try again later.",
        )
        .with(500, () => "A server error occurred. Please try again later.")
        .otherwise(() => "An unexpected error occurred. Please try again later.");
    }

    return error?.message ?? "An unexpected error occurred. Please try again later.";
  };

  if (!error) return null;

  return (
    <Styled.ErrorMessageContainer>
      <Styled.Icon />
      <Styled.ErrorMessage>{getErrorMessage()}</Styled.ErrorMessage>
    </Styled.ErrorMessageContainer>
  );
};
